<template>
  <section class="content">
    <div class="row">
      <modal-boleto
        v-if="showModalBoleto && ultimaSolicitacao"
        :solicitacao="ultimaSolicitacao"
        @close="() => { showModalBoleto = false; ultimaSolicitacao = null; this.selecionaProximo(); }"
      ></modal-boleto>

      <modal-duplicacao
        v-if="showModalDuplicacao"
        :solicitacoesNaoResolvidas="solicitacoesNaoResolvidas"
        @confirma="(justificativa) => confirmaDuplicacao(justificativa)"
        @close="() => { showModalDuplicacao = false; solicitacoesNaoResolvidas = [] }"
      ></modal-duplicacao>

      <modal-extrapolacao
        v-if="showModalExtrapolacao"
        :vagaSelecionada="vagaSelecionada"
        @confirma="(justificativa) => confirmaExtrapolacao(justificativa)"
        @close="() => { showModalExtrapolacao = false; vagaSelecionada = null }"
      ></modal-extrapolacao>

      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Resolução da Solicitação</b>
            </h3>
          </div>
          <div class="box-body">
            <pre>{{ vagaSelecionada }}</pre>
            <section>
              <!--Tabela de Procedimentos-->
              <div class="panel panel-default panel-table">
                <div class="panel-heading">
                  <div class="row">
                    <div class="col col-xs-12">
                      <h3 @click="teste()" class="panel-title">
                        <b>Procedimentos da Solicitação</b>
                        <small>Selecione um procedimento para verificar os atendimentos disponíveis.</small>
                      </h3>
                    </div>
                  </div>
                </div>
                <div>
                  <table
                    class="table table-striped table-bordered table-list stripe table-hover table-seleciona-procedimento"
                  >
                    <thead>
                      <tr>
                        <th style="width:8%">Status</th>
                        <th>Qtd.</th>
                        <th>Código</th>
                        <th style="width:50%">Nome</th>
                        <th style="width: 25%">Tipo de Pendência</th>
                      </tr>
                    </thead>
                    <tbody id="corpo-table-procedimentos-agendados">
                      <tr
                        :class="{'ativa': procedimentoSelecionado.index === index, 'resolvido': item.status == 'resolvido', 'pendente': item.status == 'pendente'}"
                        v-for="(item, index) in procedimentos.individual"
						:key="index"
                        style="cursor: pointer"
                        @click="selecionaProcedimentoIndividual(index, item)"
                      >
                        <td style="text-align:center">
                          <i
                            :title="item.status == 'resolvido'? 'Resolvido':'Pendente'"
                            :class="item.status == 'resolvido'?'fa fa-check':'fa fa-exclamation-triangle'"
                          ></i>
                        </td>
                        <td>{{ item.procedimento_quantidade }}</td>
                        <td>{{ item.procedimento_codigo }}</td>
                        <td>{{ item.procedimento_nome | uppercase }}</td>
                        <td>AGENDAMENTO</td>
                      </tr>

                      <tr
                        style="cursor: pointer"
                        v-for="(item, index) in procedimentos.agrupado"
                        :key="item.id"
                        @click="selecionaProcedimentoAgrupado(index, item)"
                        :class="{'ativa': procedimentoSelecionado.index === index, 'resolvido': item[0].status == 'resolvido', 'pendente': item[0].status == 'pendente'}"
                      >
                        <td style="text-align:center; vertical-align: middle">
                          <i
                            :title="item[0].status == 'resolvido'? 'Resolvido':'Pendente'"
                            :class="item[0].status == 'resolvido'?'fa fa-check':'fa fa-exclamation-triangle'"
                          ></i>
                        </td>
                        <td>
                          <span v-for="proc in item">
                            {{proc.procedimento_quantidade}}
                            <br />
                          </span>
                        </td>
                        <td>
                          <span v-for="proc in item">
                            {{proc.procedimento_codigo}}
                            <br />
                          </span>
                        </td>
                        <td>
                          <span v-for="proc in item">
                            {{proc.procedimento_nome | uppercase}}
                            <br />
                          </span>
                        </td>
                        <td style="vertical-align: middle">
                          <span>[{{item[0].procedimento_tipo_agrupamento | tipoAgrupamento }}] SELEÇÃO DE UNIDADES PARA AGRUPADOS</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
            <resolucao-agrupado
              :solicitacao-id="solicitacaoId"
              @confirma="(vagasSelecionadas) => {confirmaAgrupado(vagasSelecionadas)}"
              @enviaRegulacao="(vagasSelecionadas, motivo) => {enviaRegulacaoAgrupado(vagasSelecionadas, motivo)}"
              v-if="procedimentoSelecionado.tipo == 'agrupado'"
              :vagasApi="vagasApi"
              :dataNascimentoPaciente="this.$store.state.solicitacao.dadosResolucao.paciente.data_nascimento"
            ></resolucao-agrupado>
            <resolucao-individual
              :solicitacao-id="solicitacaoId"
              @confirma="(vagaSelecionada) => {confirmaIndividual(vagaSelecionada)}"
              @enviaRegulacao="(vagaSelecionada, motivo) => {enviaRegulacaoIndividual(vagaSelecionada, motivo)}"
              v-if="procedimentoSelecionado.tipo == 'individual'"
              :vagasApi="vagasApi"
              :tipoVaga="procedimentoSelecionado.tipo_consulta"
              :dataNascimentoPaciente="this.$store.state.solicitacao.dadosResolucao.paciente.data_nascimento"
            ></resolucao-individual>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import groupBy from "json-groupby";
import ResolucaoIndividual from "./resolucaoIndividual";
import ResolucaoAgrupado from "./resolucaoAgrupado";
import ModalBoleto from "./modalBoleto";
import ModalDuplicacao from "./modalDuplicacao";
import ModalExtrapolacao from "./modalExtrapolacao";

export default {
  data: () => ({
    vagaSelecionada: null,
    showModalBoleto: false,
    showModalDuplicacao: false,
    showModalExtrapolacao: false,
    justificativaDuplicacao: "",
    justificativaExtrapolacao: "",
    inputTemp: {},
    ultimaSolicitacao: null,
    procedimentoSelecionado: {
      index: null,
      tipo: null,
      itens: [] // utilizado somente pra agrupados
    },
    filtros: {
      pesquisa: "",
      coluna: 3,
      ordem: 4
    },
    procedimentos: {
      individual: [],
      agrupado: []
    },
    vagasApi: [],
    solicitacaoRegulacao: {
      created_at: "",
      id: "",
      itens: [
        {
          contrato_procedimento: {
            contrato: {
              unidade: {
                nome: ""
              }
            },
            procedimento: {
              nome: ""
            }
          },
          contrato_procedimento_atendimento: {
            profissional: {
              nome: ""
            }
          }
        }
      ],
      paciente: "",
      paciente_id: "",
      profissional: "",
      profissional_solicitante_id: "",
      situacao: "",
      solicitacao_historicos: [],
      diagnosticos: [],
      updated_at: "",
      usuario: "",
      usuario_solicitante_id: ""
    },
    solicitacao: {
      dadosResolucao: {
        paciente: {
          nome: "",
          nome_mae: "",
          data_nascimento: "",
          rg: "",
          cartao_sus: "",
          municipio: ""
        },
        profissionalSolicitante: {
          nome: "",
          situacao: "",
          data_admissao: "",
          data_desligamento: "",
          data_nascimento: "",
          sexo: "",
          rg: "",
          orgao_emissor: "",
          uf_orgao_emissor: "",
          data_emissao: "",
          cpf: "",
          telefone: "",
          hora_inicial: "",
          hora_final: ""
        },
        procedimentos: [],
        diagnosticos: [],
        solicitacao_regulacao: false,
        solicitacaoId: null,
        solicitacoesNaoResolvidas: []
      }
    }
  }),
  mounted() {
    if (this.$route.params.solicitacaoId > 0) {
      this.solicitacaoId = this.$route.params.solicitacaoId;
      this.getSolicitacaoRegulacao(this.$route.params.solicitacaoId);
      console.log("SolicitacaoID " + this.$route.params.solicitacaoId);
    } else {
      this.trataDadosResolucao();
    }
  },
  methods: {
    teste() {
      console.log(this.$store.state.solicitacao);
    },
    trataDadosResolucao() {
      let procedimentosIndividual = [];
      let procedimentosAgrupado = [];
      this.$store.state.solicitacao.dadosResolucao.procedimentos.map(
        contratoProcedimento => {
          let obj = {
            id: contratoProcedimento.id,
            procedimento_codigo: contratoProcedimento.procedimento.codigo,
            procedimento_nome: contratoProcedimento.procedimento.nome,
            procedimento_id: contratoProcedimento.procedimento.id,
            procedimento_quantidade:
              contratoProcedimento.procedimento.quantidade,
            procedimento_tipo_atendimento:
              contratoProcedimento.procedimento.tipo_atendimento,
            procedimento_tipo_agrupamento:
              contratoProcedimento.procedimento.tipo_agrupamento,
            procedimento_tipo_consulta:
              contratoProcedimento.procedimento.tipo_consulta,
            status: "pendente"
          };
          if (obj.procedimento_tipo_atendimento == 0) {
            procedimentosIndividual.push(obj);
          } else if (obj.procedimento_tipo_atendimento == 1) {
            procedimentosAgrupado.push(obj);
          }
        }
      );

      this.procedimentos.individual = procedimentosIndividual;
      this.procedimentos.agrupado = groupBy(procedimentosAgrupado, [
        "procedimento_tipo_agrupamento"
      ]);

      this.$nextTick(() => {
        if (this.procedimentos.individual.length > 0) {
          this.selecionaProcedimentoIndividual(0, procedimentosIndividual[0]);
        } else {
          let agrupadoIndex = Object.keys(this.procedimentos.agrupado);
          let temp = [];
          procedimentosAgrupado.map(procedimento => {
            if (
              procedimento.procedimento_tipo_agrupamento == agrupadoIndex[0]
            ) {
              temp.push(procedimento);
            }
          });
          this.selecionaProcedimentoAgrupado(agrupadoIndex[0], temp);
        }
      });
    },
    selecionaProximo: function() {
      let proximaSelecao = null;
      let contIndividual = 0;
      let contAgrupado = 0;
      for (let i = 0; i < this.procedimentos.individual.length; i++) {
        if (this.procedimentos.individual[i].status != "resolvido") {
          proximaSelecao = this.procedimentos.individual[i];
          break;
        }
        contIndividual++;
      }
      if (proximaSelecao) {
        this.selecionaProcedimentoIndividual(contIndividual, proximaSelecao);
        proximaSelecao = null;
      } else {
        let procedimentosAgrupados = Object.values(this.procedimentos.agrupado);
        for (let i = 0; i < procedimentosAgrupados.length; i++) {
          if (this.procedimentos.agrupado[i][0].status != "resolvido") {
            proximaSelecao = this.procedimentos.agrupado[0];
            break;
          }
          contAgrupado++;
        }
        if (proximaSelecao) {
          this.selecionaProcedimentoAgrupado(
            String(contAgrupado),
            proximaSelecao
          );
          proximaSelecao = null;
        } else {
          this.$swal({
            type: "success",
            title: "Todos os procedimentos foram resolvidos!",
            showConfirmButton: false,
            timer: 2000
          }).then(() => {
            this.$store.state.solicitacao.dadosResolucao = null;
            this.$router.push("/atendimentos/solicitacao");
          });
        }
      }
    },
    sortByKey: function(field) {
      this.dados.coluna = field;
      if (this.dados.ordem == "asc") {
        this.dados.ordem = "desc";
      } else {
        this.dados.ordem = "asc";
      }
    },
    selecionaProcedimentoIndividual(index, contratoProcedimento) {
      if (contratoProcedimento.status != "resolvido") {
        this.procedimentoSelecionado = {
          index: null,
          tipo: null,
          itens: []
        };
        this.procedimentoSelecionado.index = index;
        this.procedimentoSelecionado.tipo = "individual";
        this.procedimentoSelecionado.contrato_procedimento_id =
          contratoProcedimento.id;
        this.procedimentoSelecionado.quantidade =
          contratoProcedimento.procedimento_quantidade;
        this.procedimentoSelecionado.tipo_atendimento =
          contratoProcedimento.procedimento_tipo_atendimento;
        this.procedimentoSelecionado.tipo_consulta =
          contratoProcedimento.procedimento_tipo_consulta;
        this.procedimentoSelecionado.paciente_sexo = this.$store.state.solicitacao.dadosResolucao.paciente.sexo;
        this.procedimentoSelecionado.paciente_idade = this.$store.state.solicitacao.dadosResolucao.paciente.data_nascimento;
        this.getAtendimentosIndividual(contratoProcedimento.id);
      }
    },

    selecionaProcedimentoAgrupado(index, contratoProcedimentoArray) {
      this.procedimentoSelecionado = {
        index: null,
        tipo: null,
        itens: []
      };

      this.procedimentoSelecionado.index = index;
      this.procedimentoSelecionado.tipo = "agrupado";
      contratoProcedimentoArray.map(contratoProcedimento => {
        this.procedimentoSelecionado.itens.push({
          contrato_procedimento_id: contratoProcedimento.id,
          quantidade: contratoProcedimento.procedimento_quantidade,
          tipo_atendimento: contratoProcedimento.procedimento_tipo_atendimento,
          tipo_consulta: contratoProcedimento.procedimento_tipo_consulta,
          procedimento_id: contratoProcedimento.procedimento_id,
          paciente_sexo: this.$store.state.solicitacao.dadosResolucao.paciente
            .sexo,
          paciente_idade: this.$store.state.solicitacao.dadosResolucao.paciente
            .data_nascimento,
          procedimento_nome: contratoProcedimento.procedimento_nome
        });
      });
      this.getAtendimentosAgrupado(this.procedimentoSelecionado.itens);
    },

    getAtendimentosIndividual(contratoProcedimento) {
      this.loading = true;
      let config = this.$store.getters.getHeaderAuth;
      config.params = {
        procedimentoSelecionado: JSON.stringify(this.procedimentoSelecionado)
      };

      axios
        .get(
          `${this.$store.state.serverURI}/api/distribuicao/getAtendimentosByContratoProcedimento/${contratoProcedimento}`,
          config
        )
        .then(response => {
          console.log(response);
          if (!Array.isArray(response.data) || !response.data.length) {
            this.$swal({
              type: "warning",
              title: "Não há atendimentos disponíveis!",
              text:
                "Não encontramos nenhum atendimento disponível para o procedimento selecionado!",
              showConfirmButton: true
            });
            this.vagasApi = null;
          } else {
            this.vagasApi = response.data;
          }
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    getAtendimentosAgrupado(contratoProcedimentoArray) {
      this.loading = true;
      let config = this.$store.getters.getHeaderAuth;
      config.params = {
        contrato_procedimentos: JSON.stringify(contratoProcedimentoArray)
      };

      axios
        .get(
          `${this.$store.state.serverURI}/api/distribuicao/getAtendimentosByArrayContratoProcedimentos`,
          config
        )
        .then(response => {
          console.log(response);
          this.vagasApi = response.data;
          this.loading = false;
          this.$store.commit("TOGGLE_LOADING");
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    async getSolicitacoesNaoResolvidasByPacienteAndSolicitacaoItens(obj) {
      let solicitacoes;
      await axios
        .post(
          `${this.$store.state.serverURI}/api/atendimentos/getSolicitacoesNaoResolvidasByPacienteAndSolicitacaoItens`,
          obj,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          solicitacoes = response.data;
        })
        .catch(error => {
          console.log(error);
        });

      return solicitacoes;
    },

    preparaRequestIndividual(vagaSelecionada) {
      let obj = {
        profissionalSolicitanteId: this.$store.state.solicitacao.dadosResolucao
          .profissionalSolicitante.id,
        pacienteId: this.$store.state.solicitacao.dadosResolucao.paciente.id,
        tipoAtendimento: 0,
        itens: [],
        diagnosticos: this.$store.state.solicitacao.dadosResolucao.diagnosticos
      };
      obj.itens.push({
        distribuicao_contrato_procedimento_solicitante_id: this
          .procedimentoSelecionado.contrato_procedimento_id,
        distribuicao_contrato_procedimento_atendimento_prestador_id:
          vagaSelecionada.tipoVaga == "procedimento"
            ? vagaSelecionada.atendimento_id
            : null,
        distribuicao_contrato_subgrupo_atendimento_prestador_id:
          vagaSelecionada.tipoVaga == "subgrupo"
            ? vagaSelecionada.atendimento_id
            : null,
        quantidade: this.procedimentoSelecionado.quantidade,
        tipo_consulta: this.procedimentoSelecionado.tipo_consulta,
        paciente_idade: this.$store.state.solicitacao.dadosResolucao.paciente
          .data_nascimento,
        paciente_sexo: this.$store.state.solicitacao.dadosResolucao.paciente
          .sexo
      });

      let promise = this.getSolicitacoesNaoResolvidasByPacienteAndSolicitacaoItens(
        obj
      );
      promise.then(solicitacoes => {
        if (solicitacoes.length > 0) {
          this.inputTemp = obj;
          this.solicitacoesNaoResolvidas = solicitacoes;
          this.showModalDuplicacao = true;
        } else {
          this.marcaIndividual(obj);
        }
      });
    },

    confirmaDuplicacao(justificativa) {
      this.justificativaDuplicacao = justificativa;
      let obj = this.inputTemp;
      obj.justificativa = this.justificativaDuplicacao;
      this.marcaIndividual(obj);
      this.showModalDuplicacao = false;
      this.inputTemp = {};
      this.justificativaDuplicacao = "";
    },

    marcaIndividual(obj) {
	let loader = this.$loading.show()
      if (this.$store.state.solicitacao.dadosResolucao.solicitacao_regulacao) {
        obj.justificativa_extrapolacao = this.justificativaExtrapolacao;
        obj.solicitacaoId = this.$route.params.solicitacaoId;
        axios
          .post(
            `${this.$store.state.serverURI}/api/atendimentos/regular`,
            obj,
            this.$store.getters.getHeaderAuth
          )
          .then(response => {
			loader.hide()
            if (response.data.status == false) {
              this.$swal({
                type: "warning",
                title: response.data.title,
                text: response.data.msg,
                showConfirmButton: true
              });
            } else {
              this.justificativaExtrapolacao = "";
              this.vagaSelecionada = null;
              // let solicitacao = response.data.obj;
              this.procedimentos.individual[this.procedimentoSelecionado.index].status = "resolvido";
              this.$swal({
                type: "success",
                title: "Regulação realizada com sucesso!",
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.$router.go(-2);
                // this.$router.push('/atendimentos/regulacao');
              });
            }
          })
          .catch(error => {
            loader.hide()
            var erros = error.response.data.message + " ";
            for (var erro of Object.values(error.response.data.errors)) {
              erros += erro + " \n";
            }
            this.$swal({
              type: "error",
              title: "Houve uma falha!",
              text: erros
            });
          });
      } else {
        axios
          .post(
            `${this.$store.state.serverURI}/api/atendimentos/marcar`,
            obj,
            this.$store.getters.getHeaderAuth
          )
          .then(response => {
			loader.hide()
            if (response.data.status == false) {
              this.$swal({
                type: "warning",
                title: response.data.title,
                text: response.data.msg,
                showConfirmButton: true
              });
            } else {
              let solicitacao = response.data.obj;
              this.procedimentos.individual[this.procedimentoSelecionado.index].status = "resolvido";
              this.$swal({
                type: "success",
                title: "Marcação realizada com sucesso!",
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.showBoleto(solicitacao);
              });
            }
          })
          .catch(error => {
			loader.hide()
            var erros = error.response.data.message + " ";
            for (var erro of Object.values(error.response.data.errors)) {
              erros += erro + " \n";
            }
            this.$swal({
              type: "error",
              title: "Houve uma falha!",
              text: erros
            });
          });
      }
    },
    confirmaIndividual(vagaSelecionada) {
      if (
        vagaSelecionada.vagaPrestador == false ||
        vagaSelecionada.cotaPrestador == false ||
        vagaSelecionada.cotaSolicitante == false
      ) {
        this.vagaSelecionada = vagaSelecionada;
        this.showModalExtrapolacao = true;
      } else {
        this.preparaRequestIndividual(vagaSelecionada);
      }
    },

    confirmaExtrapolacao(justificativa) {
      this.justificativaExtrapolacao = justificativa;
      this.preparaRequestIndividual(this.vagaSelecionada);
      this.showModalExtrapolacao = false;
    },

    enviaRegulacaoIndividual(vagaSelecionada, motivo) {
	let loader = this.$loading.show()
      let obj = {
        profissionalSolicitanteId: this.$store.state.solicitacao.dadosResolucao
          .profissionalSolicitante.id,
        pacienteId: this.$store.state.solicitacao.dadosResolucao.paciente.id,
        tipoAtendimento: 0,
        itens: [],
        diagnosticos: this.$store.state.solicitacao.dadosResolucao.diagnosticos,
        observacao: motivo
      };

      if (vagaSelecionada) {
        obj.itens.push({
          distribuicao_contrato_procedimento_solicitante_id: this
            .procedimentoSelecionado.contrato_procedimento_id,
          distribuicao_contrato_procedimento_atendimento_prestador_id:
            vagaSelecionada.tipoVaga == "procedimento"
              ? vagaSelecionada.atendimento_id
              : null,
          distribuicao_contrato_subgrupo_atendimento_prestador_id:
            vagaSelecionada.tipoVaga == "subgrupo"
              ? vagaSelecionada.atendimento_id
              : null,
          quantidade: this.procedimentoSelecionado.quantidade,
          tipo_consulta: this.procedimentoSelecionado.tipo_consulta
        });
      } else {
        obj.itens.push({
          distribuicao_contrato_procedimento_solicitante_id: this
            .procedimentoSelecionado.contrato_procedimento_id,
          quantidade: this.procedimentoSelecionado.quantidade,
          tipo_consulta: this.procedimentoSelecionado.tipo_consulta
        });
      }

      axios
        .post(
          `${this.$store.state.serverURI}/api/atendimentos/enviarRegulacao`,
          obj,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
		loader.hide()
          if (response.data.status) {
            let solicitacao = response.data.obj;
            this.procedimentos.individual[this.procedimentoSelecionado.index].status = "resolvido";

            this.$swal({
              type: "success",
              title: response.data.msg,
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.showBoleto(solicitacao);
            });
          } else {
            this.$swal({
              type: "error",
              title: "Impossível prosseguir!",
              text: response.data.msg
            });
          }
        })
        .catch(error => {
		loader.hide()
          var erros = error.response.data.message + " ";
          for (var erro of Object.values(error.response.data.errors)) {
            erros += erro + " \n";
          }
          this.$swal({
            type: "error",
            title: "Houve uma falha!",
            text: erros
          });
        });
    },
    confirmaAgrupado(vagasSelecionadas) {
	let loader = this.$loading.show()
      let obj = {
        profissionalSolicitanteId: this.$store.state.solicitacao.dadosResolucao
          .profissionalSolicitante.id,
        pacienteId: this.$store.state.solicitacao.dadosResolucao.paciente.id,
        tipoAtendimento: 1,
        itens: [],
        diagnosticos: this.$store.state.solicitacao.dadosResolucao.diagnosticos
      };

      vagasSelecionadas.map(vagaSelecionada => {
        this.procedimentoSelecionado.itens.map(proc => {
          if (
            vagaSelecionada.procedimento_id == proc.procedimento_id &&
            vagaSelecionada.ativo
          ) {
            obj.itens.push({
              distribuicao_contrato_procedimento_solicitante_id:
                proc.contrato_procedimento_id,
              distribuicao_contrato_procedimento_atendimento_prestador_id:
                vagaSelecionada.tipoVaga == "procedimento"
                  ? vagaSelecionada.atendimento_id
                  : null,
              distribuicao_contrato_subgrupo_atendimento_prestador_id:
                vagaSelecionada.tipoVaga == "subgrupo"
                  ? vagaSelecionada.atendimento_id
                  : null,
              quantidade: proc.quantidade,
              tipo_consulta: proc.tipo_consulta,
              paciente_idade: this.$store.state.solicitacao.dadosResolucao
                .paciente.data_nascimento,
              paciente_sexo: this.$store.state.solicitacao.dadosResolucao
                .paciente.sexo
            });
          }
        });
      });

      axios
        .post(
          `${this.$store.state.serverURI}/api/atendimentos/marcar`,
          obj,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
		loader.hide()
          if (response.data.status == false) {
            this.$swal({
              type: "warning",
              title: "Limite Excedido!",
              text: response.data.msg,
              showConfirmButton: true
            });
          } else {
            let solicitacao = response.data.obj;
            this.procedimentos.agrupado[this.procedimentoSelecionado.index][0].status = "resolvido";

            this.$swal({
              type: "success",
              title: response.data.msg,
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.showBoleto(solicitacao);
            });
          }
        })
        .catch(error => {
		loader.hide()
          var erros = error.response.data.message + " ";
          for (var erro of Object.values(error.response.data.errors)) {
            erros += erro + " \n";
          }
          this.$swal({
            type: "error",
            title: "Houve uma falha!",
            text: erros
          });
        });
    },
    enviaRegulacaoAgrupado(vagasSelecionadas, motivo) {
	let loader = this.$loading.show()
      let obj = {
        profissionalSolicitanteId: this.$store.state.solicitacao.dadosResolucao
          .profissionalSolicitante.id,
        pacienteId: this.$store.state.solicitacao.dadosResolucao.paciente.id,
        tipoAtendimento: 1,
        itens: [],
        diagnosticos: this.$store.state.solicitacao.dadosResolucao.diagnosticos,
        observacao: motivo
      };

      vagasSelecionadas.map(vagaSelecionada => {
        this.procedimentoSelecionado.itens.map(proc => {
          if (vagaSelecionada.procedimento_id == proc.procedimento_id) {
            obj.itens.push({
              distribuicao_contrato_procedimento_solicitante_id:
                proc.contrato_procedimento_id,
              distribuicao_contrato_procedimento_atendimento_prestador_id:
                vagaSelecionada.tipoVaga == "procedimento"
                  ? vagaSelecionada.atendimento_id
                  : null,
              distribuicao_contrato_subgrupo_atendimento_prestador_id:
                vagaSelecionada.tipoVaga == "subgrupo"
                  ? vagaSelecionada.atendimento_id
                  : null,
              quantidade: proc.quantidade,
              tipo_consulta: proc.tipo_consulta
            });
          }
        });
      });
      axios
        .post(
          `${this.$store.state.serverURI}/api/atendimentos/enviarRegulacao`,
          obj,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
		loader.hide()
          if (response.data.status) {
            let solicitacao = response.data.obj;
            this.procedimentos.agrupado[this.procedimentoSelecionado.index][0].status = "resolvido";
            this.$swal({
              type: "success",
              title: response.data.msg,
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.showBoleto(solicitacao);
            });
          } else {
            this.$swal({
              type: "error",
              title: "Impossível prosseguir!",
              text: response.data.msg
            });
          }
        })
        .catch(error => {
		loader.hide()
          var erros = error.response.data.message + " ";
          for (var erro of Object.values(error.response.data.errors)) {
            erros += erro + " \n";
          }
          this.$swal({
            type: "error",
            title: "Houve uma falha!",
            text: erros
          });
        });
    },
    showBoleto(solicitacao) {
      this.ultimaSolicitacao = solicitacao;
      this.showModalBoleto = true;
    },
    getPaciente(pacienteId) {
      axios
        .get(
          `${this.$store.state.serverURI}/api/cadastros/pacientes/getById/${pacienteId}`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          this.$store.state.dadosResolucao.paciente = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getProfissional(profissionalId) {
      axios
        .get(
          `${this.$store.state.serverURI}/api/cadastros/profissionais/getById/${profissionalId}`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          this.$store.state.dadosResolucao.profissionalSolicitante =
            response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getContratoProcedimento(contratoProcedimentoId) {
      axios
        .get(
          `${this.$store.state.serverURI}/api/distribuicao/getDistribuicaoContratoProcedimentosPaginate${contratoProcedimentoId}`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          this.solicitacao.dadosResolucao.procedimentos.push(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    getSolicitacaoRegulacao(solicitacaoId) {
      axios
        .get(
          `${this.$store.state.serverURI}/api/atendimentos/getById/${solicitacaoId}`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          let itensSolicitacao = response.data.itens;
          let procedimentos = [];
          itensSolicitacao.map(item => {
            item.contrato_procedimento.procedimento.quantidade =
              item.quantidade;
            item.contrato_procedimento.procedimento.tipo_consulta =
              item.tipo_consulta;
            procedimentos.push(item.contrato_procedimento);
          });
          // response.data.diagnosticos.forEach(diagnosticoTemp => {
          // this.solicitacao.dadosResolucao.diagnosticos.push(diagnosticoTemp);
          // });
          this.solicitacao.dadosResolucao.solicitacao_regulacao = true;
          this.solicitacao.dadosResolucao.regulacao = procedimentos;
          this.solicitacao.dadosResolucao.procedimentos = procedimentos;
          this.solicitacao.dadosResolucao.paciente = response.data.paciente;
          this.solicitacao.dadosResolucao.profissionalSolicitante =
            response.data.profissional;
          this.$store.state.solicitacao.dadosResolucao = this.solicitacao.dadosResolucao;

          this.$nextTick(() => {
            this.trataDadosResolucao();
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    page: function(val) {
      this.getDataTable();
    }
  },

  components: {
    ResolucaoIndividual,
    ResolucaoAgrupado,
    ModalBoleto,
    ModalDuplicacao,
    ModalExtrapolacao
  }
};
</script>

<style scoped>
.ativa {
  background-color: #fdf59a !important;
  color: #333;
}

.ativa:hover {
  background-color: #fdf59a !important;
  color: #333;
}

.pendente {
  cursor: pointer;
}

.resolvido {
  color: #3c763d;
  background-color: #dff0d8 !important;
  cursor: default !important;
}

.resolvido:hover {
  color: #3c763d;
  background-color: #dff0d8 !important;
  cursor: default !important;
}
</style>



// WEBPACK FOOTER //
// resolucao.vue?2a3472da